/*
import { Component, inject, OnInit } from '@angular/core';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserDataModalComponent } from 'src/app/component/user-data-modal/user-data-modal.component';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false,
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  public isGlobalbar: boolean = false;
  public main: boolean = false;
  user: boolean = false;
  public snackbar = inject(MatSnackBar);
  public from: any;
  public to: any[] = [];
  public subject: any;
  public body: any;
  public provider: any;
  public dialogConfig: any = {};
  supportEmail: any = 'mctpvsupport@pearson.com';
  isDisabled: boolean = false;
  isPayDisabled: boolean = false;
  isLinkDisabled: boolean = false;
  public simpleDialog!: MatDialogRef<UserDataModalComponent>;
  constructor(private dialogModel: MatDialog, private _sppdashboard: SppdashboardService, private router: Router, private _auth: AuthService) { }

  ngOnInit(): void {
    this._auth.currentMessage.subscribe((message: any) => {
      if (typeof (message) == 'object') {

        if (message.role == 'ADMIN' && !message?.partnerName) {
          this.router.navigate(['/admin/dashboard']);
        }
      }
    });


    this._sppdashboard.getUser().subscribe((response: any) => {
      this._auth.changeMessage(response.data);
      console.log('sessionStorage--:', sessionStorage.getItem('endDate') === 'null');
      console.log('response.data--:', response.data);
      const res = response.data;
      const previousStatus = res.previousStatus;
      if (res.role == "ADMIN" && !res?.partnerName) {
        this.router.navigate(['/admin/dashboard']);

      } else {

        if (res.status == "SUSPEND" || res.status == "RENEWAL_SUSPEND") {
          const message = `<h2 style="text-align:center">Your account has been suspended</h2><p style="text-align:center">Please contact support to resolve this issue.</p><br/><a style="text-align:center;text-decoration: none" href="mailto:${this.supportEmail}">Contact support</a>`;
          const response = {
            message: message,
            data: {
              status: "SUSPEND"
            }
          }

          this.dialogConfig.value = response;
          this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });

        } else if (res.status == "RENEWAL_REJECT" || res.status == "RENEWAL") {
          this.user = true;
          if (res.status == "RENEWAL_REJECT" && this.isGreaterThanYear(res.mctSubscriptionStartDate)) {
            this.user = false;
          }
          if (this.router.url !== '/vouchers' && this.router.url !== '/home' && this.router.url !== '/login') {
            this.router.navigate([this.router.url]);
          }
          else {
            this.router.navigate(['/home']);
          }

        } else if (res.status == 'FIRST_LOGIN') {
          this.user = false;
          if (res.termsAndConditions == false || res.termsAndConditions == null) {
            this.router.navigate(['/terms']);
          }
          else if (res.termsAndConditions === true) {
            this.router.navigate(['/dashboard']);
          }
        } else if (res.status == "REJECT" || res.status == "OPEN" || res.status === "TEST_OUT_FAIL" || res.status === "ILT_OPEN" || res.status === "ILT_FAIL") {
          this.router.navigate(['/dashboard']);
        }
        else if (res.status === "TEST_OUT_OPEN" && previousStatus != 'RENEWAL') {
          this.router.navigate(['/dashboard']);
        } else if (res.status == "RENEWAL_EXAM" || (previousStatus === 'RENEWAL' && (res.status === "TEST_OUT_PASS" || res.status === "ILT_PAYMENT" || res.status === "TEST_OUT_PAYMENT" || res.status === "TEST_OUT_FAIL" || res.status === "TEST_OUT_OPEN")) || res.status === "APPROVE" || res.status === "RENEWAL_APPROVE" || res.status === "REINSTATE_APPROVE" || res.status === "ACTIVE_MCT" || res.status === "ALUMNI") {
          // RENEWAL UPDATED FLOW - previousStatus === 'RENEWAL'
          this.router.navigate(['/home']);
        } else if (res.status === 'EXPIRED' || res.status === 'REINSTATE_SUBMIT' || res.status === 'REINSTATE_REJECT') {
          this.router.navigate(['/expired-mct']);
        }

      }
    })
  }

  openHelpRequestForm = () => {
    sessionStorage.setItem('fromDashboard', 'true');
    this.router.navigate(['/support']);
  }

  isGreaterThanYear(dateParam: Date) {
    const currentDate = new Date();
    const oneYearEarlier = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1));
    return dateParam < oneYearEarlier;
  }

}

*/





import { Component, inject, OnInit } from '@angular/core';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserDataModalComponent } from 'src/app/component/user-data-modal/user-data-modal.component';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false,
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  public isGlobalbar: boolean = false;
  public main: boolean = false;
  user: boolean = false;
  public snackbar = inject(MatSnackBar);
  public from: any;
  public to: any[] = [];
  public subject: any;
  public body: any;
  public provider: any;
  public dialogConfig: any = {};
  supportEmail: any = 'mctpvsupport@pearson.com';
  isDisabled: boolean = false;
  isPayDisabled: boolean = false;
  isLinkDisabled: boolean = false;
  public simpleDialog!: MatDialogRef<UserDataModalComponent>;
  constructor(private dialogModel: MatDialog, private _sppdashboard: SppdashboardService, private router: Router, private _auth: AuthService) { }

  ngOnInit(): void {
    this._auth.currentMessage.subscribe((message: any) => {
      if (typeof (message) == 'object') {

        if (message.role == 'ADMIN' && !message?.partnerName) {
          this.router.navigate(['/admin/dashboard']);
        }
      }
    });


    this._sppdashboard.getUser().subscribe((response: any) => {
      this._auth.changeMessage(response.data);
      const res = response.data;
      const previousStatus = res.previousStatus;
      if (res.role == "ADMIN" && !res?.partnerName) {
        this.router.navigate(['/admin/dashboard']);
      } else {

        if (res.status == "SUSPEND" || res.status == "RENEWAL_SUSPEND") {
          const message = `<h2 style="text-align:center">Your account has been suspended</h2><p style="text-align:center">Please contact support to resolve this issue.</p><br/><a style="text-align:center;text-decoration: none" href="mailto:${this.supportEmail}">Contact support</a>`;
          const response = {
            message: message,
            data: {
              status: "SUSPEND"
            }
          }

          this.dialogConfig.value = response;
          this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });

        } else if (res.status === 'EXPIRED' || res.status === 'REINSTATE_SUBMIT' || res.status === 'REINSTATE_REJECT') {
          this.router.navigate(['/expired-mct']);
        } else if (previousStatus === 'RENEWAL') {
          if (res.status === 'ACTIVE_MCT' || res.status == 'RENEWAL_APPROVE' || res.status == "RENEWAL" || res.status === 'RENEWAL_REJECT' || res.status == "RENEWAL_EXAM" || res.status === "TEST_OUT_PASS" || res.status === "ILT_PAYMENT" || res.status === "TEST_OUT_PAYMENT" || res.status === "TEST_OUT_OPEN") {
            this.router.navigate(['/home']);
          } else if (res.status === 'ILT_FAIL' || res.status === 'ILT_OPEN' || res.status === 'TEST_OUT_FAIL') {
            this.router.navigate(['/dashboard']);
          }
        } else {
          if (res.status == "RENEWAL_REJECT" || res.status == "RENEWAL" || res.status == "RENEWAL_EXAM") {
            this.user = true;
            if (res.status == "RENEWAL_REJECT" && this.isGreaterThanYear(res.mctSubscriptionStartDate)) {
              this.user = false;
            }
            if (this.router.url !== '/vouchers' && this.router.url !== '/home' && this.router.url !== '/login') {
              this.router.navigate([this.router.url]);
            }
            else {
              this.router.navigate(['/home']);
            }

          } else if (res.status == 'FIRST_LOGIN') {
            this.user = false;
            if (res.termsAndConditions == false || res.termsAndConditions == null) {
              this.router.navigate(['/terms']);
            }
            else if (res.termsAndConditions === true) {
              this.router.navigate(['/dashboard']);
            }
          } else if (res.status == "REJECT" || res.status == "OPEN" || res.status === "TEST_OUT_FAIL" || res.status === "ILT_OPEN" || res.status === "ILT_FAIL") {
            this.router.navigate(['/dashboard']);
          }
          else if (res.status === "TEST_OUT_PASS" || res.status === "ILT_PAYMENT" || res.status === "TEST_OUT_PAYMENT" || res.status === "TEST_OUT_FAIL" || res.status === "TEST_OUT_OPEN" || res.status === "APPROVE" || res.status === "RENEWAL_APPROVE" || res.status === "REINSTATE_APPROVE" || res.status === "ACTIVE_MCT" || res.status === "ALUMNI") {
            this.router.navigate(['/home']);
          }
        }
      }
    })
  }

  openHelpRequestForm = () => {
    sessionStorage.setItem('fromDashboard', 'true');
    this.router.navigate(['/support']);
  }

  isGreaterThanYear(dateParam: Date) {
    const currentDate = new Date();
    const oneYearEarlier = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1));
    return dateParam < oneYearEarlier;
  }

}
